<template>
  <div id="systemid">
    <el-row>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="22" class="system" style="margin-top: 100px">
        <div>
          <ul>
            <li
              v-for="(item, index) in xtlist"
              :key="index"
              style="
                perspective: 1300px;
                transform-style: preserve-3d;
                cursor: pointer;
              "
              @click="goto(item)"
            >
              <div
                :class="{
                  rotatey: index + 1 > xtlist.length / 2,
                  rotatemiddle:
                    index + 1 == parseInt(xtlist.length / 2) + 1 &&
                    xtlist.length % 2 != 0,
                }"
              >
                <img v-if="item.icon" :src="item.icon" alt="" />
                <div>
                  {{ item.menuName }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      xtlist: [],
      userName: "",
      phone: "",
    };
  },
  mounted() {
    this.userName = JSON.parse(localStorage.getItem("userInfo")).account || "";
    this.phone = JSON.parse(localStorage.getItem("userInfo")).phoneNumber || "";
    this.getSystem();
  },
  methods: {
    goto(item) {
      let self = this;
      self.$http.get(
        self.api.serviceToken + `?clientId=${item.clientId}`,
        {},
        function (response) {
          if (response.code == 200) {
            if (item.manageUrl) {
              if (item.clientId == "jianceyunwei") {
                window.open(
                  item.manageUrl +
                    `?serviceToken=${response.body}&userName=${self.userName}&phone=${self.phone}`
                );
                // window.open("http://localhost:8085/#/homepage" + `?serviceToken=${response.body}&userName=${self.userName}&phone=${self.phone}`);
              } else {
                window.open(item.manageUrl + `?serviceToken=${response.body}`);
              }
            } else {
              if (item.clientId == "jianceyunwei") {
                window.open(
                  item.indexUrl +
                    `?serviceToken=${response.body}&userName=${self.userName}&phone=${self.phone}`
                );
              } else {
                window.open(item.indexUrl + `?serviceToken=${response.body}`);
              }
            }
          } else {
            self.$message({
              message: response.msg,
              type: "warning",
            });
            self.$router.push({ path: "/authFront/login" });
            return false;
          }
        },
        function (response) {
          //失败回调
        }
      );
    },
    //users/index
    getSystem() {
      let self = this;
      self.$http.post(
        self.api.usersIndex,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        (res) => {
          if (res) {
            self.xtlist = res.body.clientList;
          } else {
          }
        },
        (error) => {}
      );
    },
  },
};
</script>
<style>
#systemid a {
  text-decoration: none;
  color: #fff;
  font-size: 25px;
}
#systemid .system {
  margin-top: 80px;
  padding: 20px 50px;
  box-sizing: border-box;
  max-height: 600px;
  overflow: auto;
  color: #fff;
}
#systemid .systemFont {
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;
}
#systemid .system ul {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding-right: 20px;
}
#systemid .system ul li {
  width: 270px;
  height: 429px;
  float: left;
  text-align: center;
  border-radius: 6px;
  padding: 23px;
  box-sizing: border-box;
  transform: perspective(1000 px);
  transform-style: preserve-3d;
}
#systemid .system ul li div.rotatemiddle {
  transform: rotatey(0);
  opacity: 1;
}
#systemid .system div.rotatey {
  transform: rotatey(-30deg);
}
#systemid .system ul li > div {
  transition: transform 0.2s, opacity 0.2s;
  width: 100%;
  height: 80%;
  background: url("../assets/l_bg.png") no-repeat center top;
  background-size: contain;
  transform: rotatey(30deg);
  opacity: 0.7;
  margin: 0 auto;
  padding: 30px 20px;
}
#systemid .system ul li > div > div {
  margin-top: 60px;
  letter-spacing: 2px;
  opacity: 1;
}
#systemid .system ul li:hover div {
  transform: rotatey(0);
  opacity: 1;
}
#systemid .system .img_position {
  margin-top: 40px;
}
#systemid .system > div > div {
  font-size: 20px;
  margin-top: 20px;
  letter-spacing: 5px;
}
#systemid .system ul li img {
  width: 55%;
}
</style>


// WEBPACK FOOTER //
// src/view/systemIn.vue